import {debounce} from './utils';


class KvikPageElement extends HTMLElement {

    connectedCallback() {
        const debounceHander = debounce(() => this.displayChange(), 250);
        window.addEventListener('resize', debounceHander);

        // This runs after the browser paints, meaning all children are likely present
        requestAnimationFrame(() => this.displayChange());
    }

    displayChange() {
        this.hidden = this.areAllChildrenHidden();
        if (this.parentElement.children.length === 1) {
            this.parentElement.hidden = this.hidden;
        }
    }

    areAllChildrenHidden() {
        this.hidden = false;
        this.parentElement.hidden = false;

        const children = this.children;
        if (children.length === 0) {
            return false;
        }

        return [...children].every(child => KvikPageElement.isElementHidden(child));
    }

    static isElementHidden(el) {
        return el.hidden || window.getComputedStyle(el).display === 'none';
    }
}

window.customElements.define('kvik-page', KvikPageElement);